import styled from 'styled-components';

export const FlatCardList = styled.div`
  width: 100%;
  > :not(:last-child) {
    margin-bottom: ${(props) => `${props.theme.space[2]}px`};
  }
`;
